import React, { useRef, useImperativeHandle } from "react";
import { Grid } from "@mui/material";
import { TextField, Box } from "@curves/ui-base";
import { getErrorModuleStatus, refIsRequiredError } from "@util/utils";
import useBankAccountState from "@icoach/components/bankAccount/useBankAccountState";
import useBankAccountSubmitHandle from "@icoach/components/bankAccount/bankAccountEditor/useBankAccountSubmitHandle";

const BankAccountEditor = React.forwardRef((props, ref) => {
	const { className, sourceData, refresh } = props;

	const { bankAccountInfo, onUpdateField } = useBankAccountState(sourceData);

	const handleChange = fieldName => e => {
		const value = e.target.value;
		onUpdateField(fieldName, value);
	};

	const fieldRefs = useRef({});

	const formAdapter = {
		getFormData: () => ({ ...bankAccountInfo }),
		validateForm: () => {
			return refIsRequiredError(fieldRefs.current);
		},
	};

	const { onSubmit, checkError, validationErrors } = useBankAccountSubmitHandle({
		formAdapter,
		sourceData,
		refresh,
	});

	useImperativeHandle(
		ref,
		() => ({
			onSubmit,
			isError: checkError,
		}), // eslint-disable-next-line
		[onSubmit, checkError],
	);

	return (
		<Box className={className}>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<TextField
						label={"銀行代碼"}
						ref={ref => (fieldRefs.current["bankCode"] = ref)}
						value={bankAccountInfo?.bankCode || ""}
						{...getErrorModuleStatus(validationErrors, "bankCode")}
						onChange={handleChange("bankCode")}
						fullWidth
						required
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行名稱"}
						ref={ref => (fieldRefs.current["bankName"] = ref)}
						value={bankAccountInfo?.bankName || ""}
						{...getErrorModuleStatus(validationErrors, "bankName")}
						onChange={handleChange("bankName")}
						fullWidth
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行帳號"}
						ref={ref => (fieldRefs.current["bankAccountID"] = ref)}
						value={bankAccountInfo?.bankAccount || ""}
						{...getErrorModuleStatus(validationErrors, "bankAccount")}
						onChange={handleChange("bankAccount")}
						fullWidth
						required
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行帳戶"}
						ref={ref => (fieldRefs.current["bankAccountName"] = ref)}
						value={bankAccountInfo?.bankAccountName || ""}
						{...getErrorModuleStatus(validationErrors, "bankAccountName")}
						onChange={handleChange("bankAccountName")}
						fullWidth
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"帳戶身分證字號"}
						ref={ref => (fieldRefs.current["bankAccountID"] = ref)}
						value={bankAccountInfo?.bankAccountID || ""}
						{...getErrorModuleStatus(validationErrors, "bankAccountID")}
						onChange={handleChange("bankAccountID")}
						fullWidth
						required
					/>
				</Grid>
			</Grid>
		</Box>
	);
});

export default BankAccountEditor;
